module.exports = __webpack_public_path__ + "static/media/trial1-if-wrong.cf17c8bf.mp3";